<template>
  <v-dialog v-model="dialog" scrollable persistent :max-width="800" :fullscreen="xsOnly">
    <template v-slot:activator="{ }">
      <v-btn color="primary" :disabled="cargando || guardado" @click="abrirDialog()" class="inline-block">
        {{ $t("guardar") | capitalize }}
      </v-btn>
    </template>

    <v-card>
      <v-card-title class="primary white--text pa-2">
        <v-btn color="error" class="hidden-md-and-up" icon @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        {{ $t("descrip") }}
        <v-spacer class="hidden-md-and-up"></v-spacer>
        <v-btn color="white" class="white--text hidden-md-and-up" icon :disabled="!valido" :loading="cargando"
               @click="guardarProyecto()">
          <v-icon>mdi-content-save</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="pt-2">
        <v-text-field v-model="nombre" :label="$t('nombre') | capitalize"></v-text-field>
        <v-text-field v-model="descripcion" :label="$t('descripcion') | capitalize"></v-text-field>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="hidden-sm-and-down">
        <v-spacer></v-spacer>
        <v-btn color="error" text @click="dialog = false">
          {{ $t("cerrar") | capitalize }}
        </v-btn>
        <v-btn color="primary" text :disabled="!valido" :loading="cargando" @click="guardarProyecto()">
          {{ $t("guardar") | capitalize }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {HttpHelper} from "@/comunes/helpers/HttpHelper";
import {
  ASIG_GUARDANDO_PROYECTO,
  LIMP_GUARDANDO_PROYECTO,
  MOSTRAR_DIALOGO_CONFIRMACION,
  MOSTRAR_SNACKBAR
} from "@/store/store-app";
import {mapState} from 'vuex';
import {VueRouteHelper} from "@/comunes/helpers/VueRouteHelper";

export default {
  name: "BtnGuardar",
  props: {
    id: {required: true, type: Number}
  },
  data: () => ({
    cargando: false,
    dialog: false,
    nombre: "",
    descripcion: "",
    guardado: false
  }),
  computed: {
    ...mapState(["usuario"]),
    valido() {
      if (this.nombre.length < 3) return false;
      return this.descripcion.length >= 3;
    },
    xsOnly() {
      return this.$vuetify.breakpoint.xsOnly;
    }
  },
  mounted() {
    let pId = this.$store.getters.guardandoProyectoId;
    if (pId == null) return;

    this.$store.commit(LIMP_GUARDANDO_PROYECTO);
    if (pId === this.id) {
      if (this.usuario)
        this.$store.commit(MOSTRAR_SNACKBAR, {
          texto: this.$t("puede_guardar"),
          color: "info"
        });
      this.abrirDialog();
    }
  },
  watch: {
    id: function () {
      this.guardado = false;
    }
  },
  methods: {
    abrirDialog() {
      if (this.usuario == null) {
        this.$store.dispatch(MOSTRAR_DIALOGO_CONFIRMACION, {
          titulo: this.$t('no_usuario_titulo'),
          color: "info",
          texto: this.$t('no_usuario_pregunta')
        }).then(() => {
          this.$store.commit(ASIG_GUARDANDO_PROYECTO, this.id);
          this.$store.commit(MOSTRAR_SNACKBAR, {
            texto: this.$t("iniciar_sesion"),
            color: "info"
          });
          VueRouteHelper.goTo(`/login`, this.$router);
        }).catch(() => {
          this.$store.commit(LIMP_GUARDANDO_PROYECTO, null);
        });
      } else this.dialog = true;
    },
    guardarProyecto() {
      this.cargando = true;
      let data = {
        nombre: this.nombre,
        descripcion: this.descripcion
      };
      HttpHelper.post(`proyecto/${this.id}/guardar`, data)
          .then(() => {
            this.guardado = true;
            this.$store.commit(MOSTRAR_SNACKBAR, {
              texto: this.$t("p_guardado"),
              color: "success"
            });
            this.dialog = false;
            this.nombre = "";
            this.descripcion = "";
          })
          .catch(() => {
            this.$store.commit(MOSTRAR_SNACKBAR, {
              texto: this.$t("p_no_guardado"),
              color: "error"
            });
          })
          .finally(() => {
            this.cargando = false;
          });
    }
  }
}
</script>

<style scoped>

</style>

<!--@formatter:off-->
<i18n>
{
  "es": {
    "descrip": "Guardar proyecto",
    "nombre": "nombre",
    "descripcion": "descripción",
    "p_guardado": "Proyecto guardado",
    "p_no_guardado": "Ocurrió un error al guardar el proyecto",
    "iniciar_sesion": "Inicia sesión o registrarte para poder guardar el proyecto",
    "puede_guardar": "Ahora puede guardar el proyecto",
    "no_usuario_titulo": "Debes iniciar sesión o registrarte",
    "no_usuario_pregunta": "<span class='font-weight-bold'>Debes iniciar sesión o registrarte para poder guardar el proyecto.</span><br/>Si pulsas el botón confirmar serás redirigido a la página de inicio de sesión o registro. Una vez completado el proceso podrás guardar el proyecto."
  }
}
</i18n>
<!--@formatter:on-->